/**
 * 需求来源：docs/旅游落地页/AI提示词.md 第1次提交 需求4（任务单 DEV-120352）；
 *          视觉基准 docs/旅游落地页/cj商旅-01.html 第 3129~3330 行（.cjbt-trip-center）。
 * 注意事项：
 * 1. 本区块含两个子模块：Route Planner（5 个路线节点 + 4 个标签）与 Six Features（6 张特性卡）。
 * 2. 纯静态展示，原型无对应脚本；标题内 `<br>` + `<em>` 结构保留（em 在 CSS 里设置强调样式）。
 * 3. 描述段原型为「前文 + <strong>加粗短语</strong> + 句号后续文」，i18n 拆三段 key，
 *    tail 段以句点开头（原型 `</strong>.` 紧跟无空格），故此处不额外补空格。
 */
import React from 'react';
import { Clock } from './Icons';

export default function Trip(props) {
  var TRIP = props.data;

  return (
    <section className="cjbt-trip-center" id="customized-china-journey">
      <div className="cjbt-trip-center__container">

        {/* CENTERED TITLE */}
        <div className="cjbt-trip-center__heading">
          <div className="cjbt-trip-center__eyebrow">{TRIP.eyebrow}</div>

          <h2 className="cjbt-trip-center__title">
            {TRIP.titleLead}<br />
            <em>{TRIP.titleEm}</em>
          </h2>

          <p className="cjbt-trip-center__description">
            {TRIP.descriptionLead}{' '}
            <strong>{TRIP.descriptionStrong}</strong>
            {TRIP.descriptionTail}
          </p>
        </div>

        {/* ROUTE PLANNER */}
        <div className="cjbt-trip-center__planner">

          <div className="cjbt-trip-center__planner-heading">
            <span className="cjbt-trip-center__planner-icon"><Clock /></span>
            <span>
              <strong>{TRIP.plannerTitle}</strong>
              <small>{TRIP.plannerSubtitle}</small>
            </span>
          </div>

          <div className="cjbt-trip-center__route">
            {TRIP.routePoints.map(function (point) {
              return (
                <div className="cjbt-trip-center__route-point" key={point.node}>
                  <span className="cjbt-trip-center__route-node">{point.node}</span>
                  <span>
                    <strong>{point.title}</strong>
                    <small>{point.text}</small>
                  </span>
                </div>
              );
            })}
          </div>

          <div className="cjbt-trip-center__tags">
            {TRIP.tags.map(function (tag, index) {
              return <span className="cjbt-trip-center__tag" key={index}>{tag}</span>;
            })}
          </div>

        </div>

        {/* SIX FEATURES */}
        <div className="cjbt-trip-center__features">
          {TRIP.features.map(function (feature) {
            return (
              <article className="cjbt-trip-center__feature" key={feature.number}>
                <span className="cjbt-trip-center__feature-number">{feature.number}</span>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </article>
            );
          })}
        </div>

      </div>
    </section>
  );
}
